import React from 'react';
import { styled } from '@glitz/react';
import { TextBlockSmall, Text, ResponsiveSize } from 'Shared/SharedComponents/atoms/Typography';
import { StyleOrStyleArray } from '@glitz/type';
import * as style from 'Shared/Style';

type TagsType = {
  tags: string[];
  marginTop?: string;
  marginBottom?: string;
  nrToDisplay?: number;
  readMoreLabel?: string;
  readMoreClick?: () => void;
};

const Wrap = styled.div({
  display: 'flex', 
  flexWrap: 'wrap',
  flexDirection: 'row',
  alignItems: 'center', 
  gap: '8px',
})

const InlineWrap = styled.span({
  display: 'flex', 
  flexWrap: 'wrap',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: { x: '12px', y: '8px' },
  gap: '16px',
  height: '32px',
  backgroundColor: style.colors.monochrome.extraLightGrey,
  borderRadius: '100px',
  flexBasis: 'none',
  flexGrow: 0,
})

const ReadMoreLabel = styled(Text, {
  cursor: 'pointer',
  color: style.colors.monochrome.a11ygrey,
  ':hover': {
    color: style.colors.monochrome.black,
  }
})

function ProductTags(props: TagsType) {
  const tags = props.nrToDisplay ? props.tags && props.tags.slice(0, props.nrToDisplay) : props.tags && props.tags;

  return (
    <Wrap 
      css={{  
        ...(props.marginTop && {
          marginTop: props.marginTop
        }),
        ...(props.marginBottom && {
          marginBottom: props.marginBottom
        })
      }}
    >
      {tags && tags.map((tag, i) => (
        <BgTag key={i}>{tag}</BgTag>
      ))}
      {props.readMoreLabel && (
        <ReadMoreLabel
          upperCase
          fontSize={ResponsiveSize.D14_M14}
          onClick={props.readMoreClick}
        >
          {props.readMoreLabel}
        </ReadMoreLabel>
        )}
    </Wrap>
  );
}

export const BgTag = ({ children, css }: { children: React.ReactNode; css?: StyleOrStyleArray }) => (
  <InlineWrap
    css={{
      ...css,
    }}
  >
    <TextBlockSmall upperCase>{children}</TextBlockSmall>
  </InlineWrap>
);

export default ProductTags;
